import Component from './highlight.vue'
export default Component
